export default __webpack_public_path__ + "static/6589-58fc99e0ed5f1adb739e4d8092d8bf29.jpg";